import React, {useEffect,useState,useContext,useMemo,useCallback} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import $ from 'jquery';
import RefreshContext from './RefreshContext';
import {
  Box, 
   Button, 
  Select as MuiSelect,
  MenuItem, 
  Typography, 
  Tooltip, 
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,Checkbox} from '@mui/material'; 
import {Edit as EditIcon,Visibility as VisibilityIcon, DownloadOutlined,ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DeleteOutline, EditOutlined, VisibilityOutlined, KeyboardArrowRight, FormatListBulleted } from '@mui/icons-material';

function Demo(){
const { refreshKey } = useContext(RefreshContext);
const { aid,aidtype} = useParams();
const navigate = useNavigate();
const [requirement, setRequirement] = useState([]);
const [candidates, setStaff] = useState([]); // vendor

const [fileUrl, setFileUrl] = useState(null);
const [fileType, setFileType] = useState(null);
const [total,setTotal]= useState(0);
const [results, setResults] = useState(null);
const [showResultsModal, setShowResultsModal] = useState(false);
const [fileInfo, setFileInfo] = useState(null);

const [loadings, setTableLoading] = useState(true);
const [newloading,setNewLoading] = useState(false);
const [selectedRecruiter, selectRecruiter] = useState(null);

const [recruiter, setRecruiter] = useState([]);
const [groupedData, setGroupedData] = useState([]);
const [order, setOrder] = useState('asc'); 
const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
const [globalFilterText, setGlobalFilterText] = useState('');
const [columnFilters, setColumnFilters] = useState({});
const [stats,setStats]= useState([]);

const [experienceOptions,setExper] = useState([]);
const [qualificationOptions,setQual] = useState([]);


const [metaData, setMetaData] = useState({
  appname: '',
  edit: false,
  del: false,
  add: false,
  view: false,
  typess:'',
  icon:'',
  checkbox:0,
  defaultShow:10
});
const [currentPage, setCurrentPage] = useState(1);
const [totalRows, setTotalRows] = useState(0); // Set this from your API response
const limit = 50; 
const maxPage = Math.ceil(totalRows / limit);

const fetchData = async (page) => {
  const response = await axios.get(apiurl+'democandidate.php?subdomain=react&aid='+aid+"&page="+page); // Replace with your API endpoint

   setStaff(response.data.staff || []);
   setTotalRows(response.data.total_count);
   setExper(response.data.exper);
   setQual(response.data.quals);

   setRecruiter(response.data.recruiter);
   setGroupedData(response.data.requirements || []);
   setStats(response.data.stats || []);
 
   setMetaData({
  appname: response.data.appname,
  edit: response.data.edit,
  del:response.data.del,
  add: response.data.add == '1' ? true : false,
  view: response.data.view,
  typess:response.data.typess,
  icon:response.data.icon,
  defaultShow:response.data.defaultShow,
  checkbox:response.data.checkbox
   });

 setTotal(response.data.total);
 setTableLoading(false);

};

 const handleFileChange2 = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileInfo({
      name: file.name,
      size: (file.size / 1024).toFixed(2) // KB
    });
  };

  const [filters, setFilters] = useState({
    qual: "",
    exp: ""
  });
  
  // Helper function to update state
  const handleSelectChange = (name, selectedOption) => {
    setFilters(prev => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : ""
    }));
  };
  

const displayCount = 5;
let startPage = Math.max(1, currentPage - Math.floor(displayCount / 2));
let endPage = startPage + displayCount - 1;

if (endPage > maxPage) {
    endPage = maxPage;
    startPage = Math.max(1, endPage - displayCount + 1);
}

const pages = [];
for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
}

useEffect(() => {
  document.title = "Candidate | MERAQUI";
    fetchData(currentPage);
  $('#modalclose').on('click', function () {
    $("#hidden").val("");
    $("#reset").click();
    setFileType(null);
    setFileUrl(null);
    checks('1');


  });
  

}, [refreshKey,currentPage]);

const typeUpper = metaData.typess?.toUpperCase();

// form submit in category
const FormSubmit = async (e) =>{
          e.preventDefault();
          // try and catch method
            try {
              const formData = new FormData($("#mainForm")[0]);
              if($("#hidden").val()==""){
                if($("#resume").val().length==0){
                   Swal.fire({
                       position:'top-center',
                       icon:'question',
                       title:"Please select the resume"
                   });
                   return false;
                }
              }

              
             $("#showLoader").removeClass('d-none').addClass('d-flex');
               const response = await axios.post(apiurl + "democandidate.php", formData);
              if (response.data.status==true) {
               $("#showLoader").removeClass('d-flex').addClass('d-none');
                                      Swal.fire({
                                        position: "top-center",
                                        icon: "success",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    }).then(()=>{
                                      $(".btn-close").click();
                                      fetchData(currentPage);
                                    });
              }
              else{
               $("#showLoader").removeClass('d-flex').addClass('d-none');
                Swal.fire({
                  position: "top-center",
                  icon: "error",
                  title: response.data.message,
                  showConfirmButton: true,
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                  allowEscapeKey: false
                });
              }
            } catch (error) {
              console.log(error.response?.data?.message); // Handle errors with informative messages
            }
            finally {
                $("#loader").css("display", "none");
            }
};

// delete the data from the category
 const DeleteData = async (id) =>{
   if(!id){return false;}
     const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this data!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
      });

   if(result.isConfirmed){
    try {
       const response = await axios.get(apiurl+"democandidate.php?del="+id);
       if (response.data.status ==true) {
                                    Swal.fire({
                                        position: "top-center",
                                        icon: "success",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    }).then(()=>{
                                      fetchData(currentPage);
                                    });
  
       }
       else{
        Swal.fire({
  position: "top-center",
  icon: "error",
  title: response.data.message,
  showConfirmButton: true,
  confirmButtonText: "OK",
  allowOutsideClick: false,
  allowEscapeKey: false
});
       }
    }
    catch(error){
      console.error('Error deleting category:', error);
    }


  };
  
};

function checks(dd){
  if(dd=='1'){
       $("#mainForm input, #mainForm select").attr("required",true);
        $("#mainForm input[type=file]").attr("required",false);
         $("#mainForm input, #mainForm select").prop("readonly",false);
         $("#mainForm .btn-primary, #resumelabel").show();
  }
  else{
        $("#mainForm input, #mainForm select").attr("required",false);
         $("#mainForm input, #mainForm select").prop("readonly",true);
         $("#mainForm .btn-primary, #resumelabel").hide();
  }
}

//edit the form
const EditData = async (edit,sss=1) =>{
   if(sss==1){
      $("#showLoader").removeClass('d-none').addClass('d-flex');
        try{
        const response = await axios.get(apiurl+'democandidate.php?edit='+edit);
        if(response.data.status==true){
          $("#name").val(response.data.data[0].name);
          $("#email").val(response.data.data[0].email);
          $("#profile").val(response.data.data[0].profile);
          $("#mobile").val(response.data.data[0].phone);
          $("#age").val(response.data.data[0].age);
          $("#exp").val(response.data.data[0].exp);
          $("#age").val(response.data.data[0].age);
          $("#qual").val(response.data.data[0].qual.trim());
          $("#pincode").val(response.data.data[0].pincode);
          $("#city").val(response.data.data[0].city);
          $("#state").val(response.data.data[0].state);
          $("#hidden").val(response.data.data[0].hidden);
          setFileType(response.data.data[0].fileType);
          setFileUrl(response.data.data[0].fileUrl);
          $('#addStaffbtn').click();
            checks(sss);
        $("#showLoader").removeClass('d-flex').addClass('d-none');
        }else{
          // modal can't show
          alert("data not found");
        }
        
      }
      catch(error){
        console.error('Error deleting category:', error);
      }
  }
  else{
    $("#showLoader").removeClass('d-none').addClass('d-flex');
          const response = await axios.get(apiurl + 'view_candidate.php?edit=' + edit+"&sss="+sss);
          if (response.data.status == true) {
              setRequirement(response.data.data[0]);
              $("#tera_modal33").click();
          }
          $("#showLoader").removeClass('d-flex').addClass('d-none');
  }
};
 
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    setFileUrl(url);
    setFileType(file.type);
  };

const BulkUploadResultsModal = ({ show, onClose, results = {} }) => {
    const safeResults = results || {};
    const { alreadyExist = [], duplicate = [], unique = [] } = safeResults;

    useEffect(() => {
      if (show) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return () => (document.body.style.overflow = "");
    }, [show]);

    if (!show) return null;

    const SummaryRow = ({ label, count, colorClass }) => (
      <div className="me-3 d-flex align-items-center">
        <span
          className={`badge ${colorClass} rounded-pill me-2`}
          style={{ minWidth: 28 }}
        >
          {count}
        </span>
        <small className="text-muted">{label}</small>
      </div>
    );

    const Table = ({ title, items, emptyMessage }) => (
      <div className="mb-3">
        <h6 className="mb-2">
          {title} <small className="text-muted">({items.length})</small>
        </h6>
        <div className="table-responsive" style={{ maxHeight: "360px", overflowY: "auto" }}>
          <table className="table table-hover table-sm align-middle">
            <thead className="table-light sticky-top">
              <tr>
                <th style={{ width: "6%" }}>#</th>
                <th style={{ width: "34%" }}>Name</th>
                <th style={{ width: "24%" }}>Mobile</th>
                <th style={{ width: "30%" }}>Email</th>
                <th style={{ width: "6%" }} className="text-end">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-muted py-4">
                    {emptyMessage}
                  </td>
                </tr>
              ) : (
                items.map((it, idx) => (
                  <tr key={`${it.mobile}-${idx}`}>
                    <td>{idx + 1}</td>
                    <td
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 220,
                      }}
                      title={it.name}
                    >
                      {it.name || "-"}
                    </td>
                    <td>{it.mobile || "-"}</td>
                    <td
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 260,
                      }}
                      title={it.email}
                    >
                      {it.email || "-"}
                    </td>
                    <td className="text-end">
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => navigator.clipboard?.writeText(it.mobile || "")}
                        title="Copy mobile"
                      >
                        Copy
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );

    return (
      <>
      <div className="bulk-results-modal">
        <div className="modal-backdrop fade show"></div>
        <div className="modal d-block fade show" tabIndex={-1} role="dialog" aria-modal="true">
          <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div className="modal-content shadow-lg rounded-3">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title">Bulk Upload — Results</h5>
                  <div className="d-flex mt-1">
                    <SummaryRow label="Added (unique)" count={unique.length} colorclassName="bg-success text-white" />
                    <SummaryRow label="Duplicates in CSV" count={duplicate.length} colorclassName="bg-warning text-dark" />
                    <SummaryRow label="Already in Database" count={alreadyExist.length} colorclassName="bg-secondary text-white" />
                  </div>
                </div>
                <div>
                  <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                </div>
              </div>

              <div className="modal-body">
                <ul className="nav nav-tabs mb-3" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" data-bs-target="#added" id="tab-added" data-bs-toggle="tab" type="button" role="tab" aria-controls="added" aria-selected="true">Added</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="tab-duplicate" data-bs-target="#duplicate" data-bs-toggle="tab" type="button" role="tab" aria-controls="duplicate" aria-selected="false">Duplicates</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="tab-already" data-bs-target="#already" data-bs-toggle="tab" type="button" role="tab" aria-controls="already" aria-selected="false">Already in DB</button>
                  </li>
                </ul>

                <div className="tab-content">
                  <div className="tab-pane fade show active" id="added" role="tabpanel" aria-labelledby="tab-added">
                    <Table title="Unique / Inserted into database" items={unique} emptyMessage="No new records were inserted." />
                  </div>
                  <div className="tab-pane fade" id="duplicate" role="tabpanel" aria-labelledby="tab-duplicate">
                    <Table title="Duplicates found in CSV (skipped)" items={duplicate} emptyMessage="No duplicate mobiles found in CSV." />
                  </div>
                  <div className="tab-pane fade" id="already" role="tabpanel" aria-labelledby="tab-already">
                    <Table title="Already present in database (skipped)" items={alreadyExist} emptyMessage="No existing mobiles found in DB." />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <div className="me-auto text-muted small">
                  Total rows shown: {unique.length + duplicate.length + alreadyExist.length}
                </div>
                <button className="btn btn-outline-secondary" onClick={() => {
                  const allRows = [
                    ["type", "name", "mobile", "email"],
                    ...unique.map((i) => ["added", i.name, i.mobile, i.email]),
                    ...duplicate.map((i) => ["duplicate", i.name, i.mobile, i.email]),
                    ...alreadyExist.map((i) => ["already", i.name, i.mobile, i.email]),
                  ];
                  const csv = allRows.map(r => r.map(c => '"' + String(c || "").replace(/\"/g,'""') + '"').join(',')).join('\n');
                  const blob = new Blob([csv], { type: 'text/csv' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'bulk-upload-results.csv';
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  URL.revokeObjectURL(url);
                }}>Download CSV</button>
                <button className="btn btn-primary" onClick={onClose}>Close</button>
              </div>
            </div>
          </div>
        </div>

        {newloading && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        <style jsx>{`
          .modal-backdrop { z-index: 1040; }
          .modal { z-index: 1050; }
          .table thead.sticky-top { top: 0; }
          .loader-overlay {
            position: fixed;
            top:0; left:0; right:0; bottom:0;
            background: rgba(255,255,255,0.7);
            display:flex;
            justify-content:center;
            align-items:center;
            z-index:2000;
          }
        `}</style>
      </div>
    </>
  );

  };

// form submit in category
const BulkFormSubmit = async (e) =>{
          e.preventDefault();
          // try and catch method
            try {
              const formData = new FormData($("#bulkform")[0]);
              if($("#bulk").val().length==0){
                Swal.fire({
                       position:'top-center',
                       icon:'question',
                       title:"Please select the bulk candidate file"
                   });
                   return false;
              }
              
              $("#showLoader").removeClass("d-none").addClass("d-flex");
              const response = await axios.post(apiurl + "democandidate.php", formData);
              if (response.data.status === true) {

  setResults({
  alreadyExist: response.data.already || [],
  duplicate: response.data.duplicate || [],
  unique: response.data.unique || []
});
      setShowResultsModal(true);

      $("#modalclose2").click();
      $("#bulkform input").val("");
      fetchData(currentPage);

               }
              else{
               Swal.fire({
  position: "top-center",
  icon: "error",
  title: response.data.messages,
  showConfirmButton: true,
  confirmButtonText: "OK",
  allowOutsideClick: false,
  allowEscapeKey: false
});
              }
               $("#showLoader").removeClass("d-flex").addClass("d-none");
            } catch (error) {
              console.log(error.response?.data?.message); // Handle errors with informative messages
            }
};

const stableSort = (array, comparator) => {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
              return order;
          }
          return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
  };

const getComparator = (order, orderBy) => {
return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const descendingComparator = (a, b, orderBy) => {
const valA = orderBy(a);
const valB = orderBy(b);

if (valB < valA) {
    return -1;
}
if (valB > valA) {
    return 1;
}
return 0;
};
  
const ColumnHeaderWithFilter = ({ 
    column, 
    orderBySelector, 
    order, 
    handleRequestSort, 
    columnFilters, 
    setColumnFilters,
}) => {

    const [localOpenKey, setLocalOpenKey] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [tempFilter, setTempFilter] = useState("");

    const accessorKey = column.accessorKey;

    const isMenuOpen = localOpenKey === accessorKey;
    const currentFilter = String(columnFilters[accessorKey] || '');
    const isSorted = orderBySelector === column.selector;

    useEffect(() => {
        setTempFilter(currentFilter);
    }, [currentFilter]);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setLocalOpenKey(accessorKey);
        setTempFilter(currentFilter);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setLocalOpenKey(null);
    };

    const handleFilterChange = (e) => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: e.target.value
        }));
    };

    const handleTempChange = (e) => {
        setTempFilter(e.target.value);
    };

    const applySearch = () => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: tempFilter
        }));
        handleClose();
    };

    const isSortable = !!column.selector;
    const isFilterable = !!column.filterType;

    // --- Custom Filter Input Renderer ---
    const renderFilterInput = () => {

        if (column.filterType === 'select') {

            const filterOptions = column.dynamicFilterOptions || [];

            return (
                <MuiSelect
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    sx={{ width: '100%' }}
                >
                    <MenuItem value="">— All —</MenuItem>
                    {filterOptions.map(option => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                </MuiSelect>
            );
        }

        if (column.filterType === 'date') {
            return (
                <TextField
                    label={`Filter ${column.header}`}
                    type="date"
                    variant="outlined"
                    size="small"
                    value={currentFilter}
                    onChange={handleFilterChange}
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: '100%' }}
                />
            );
        }

        // Default: text filter (with Search button)
        return (
            <>
                <TextField
                    label={`Filter ${column.header}`}
                    variant="outlined"
                    size="small"
                    value={tempFilter}
                    onChange={handleTempChange}
                    autoFocus
                    sx={{ width: '100%' }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            applySearch();
                        }
                    }}
                />

                <Button
                    variant="contained"
                    size="small"
                    onClick={applySearch}
                    sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                >
                    Search
                </Button>
            </>
        );
    };


    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                '& .MuiTableSortLabel-root': { flexGrow: 1 }
            }}
        >
            <TableSortLabel
                active={isSorted}
                direction={isSorted ? order : 'asc'}
                onClick={() => isSortable && handleRequestSort(column.selector)}
                IconComponent={isSorted ? (order === 'desc' ? ArrowDropDown : ArrowDropUp) : undefined}
                sx={{
                    cursor: isSortable ? 'pointer' : 'default',
                    '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 'bold',
                    }
                }}
            >
                {column.header}
            </TableSortLabel>

            {isFilterable && (
                <>
                    <IconButton
                        aria-label="filter"
                        size="small"
                        onClick={handleClick}
                        sx={{
                            ml: 1,
                            p: 0,
                            color: currentFilter ? 'primary.main' : 'text.secondary',
                        }}
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>

                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleClose}
                        onClick={(e) => e.stopPropagation()}
                        PaperProps={{
                            sx: { width: 250, p: 1, boxShadow: 6, borderRadius: 2 }
                        }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >

                        <Box sx={{ width: '100%', p: 1 }}>
                            {renderFilterInput()}
                        </Box>

                        {currentFilter && (
                            <Button
                                onClick={() => {
                                    setColumnFilters(prev => ({
                                        ...prev,
                                        [accessorKey]: ''
                                    }));
                                    handleClose();
                                }}
                                size="small"
                                color="error"
                                sx={{ mt: 1, textTransform: 'none', width: "100%" }}
                            >
                                Clear Filter
                            </Button>
                        )}

                    </Menu>
                </>
            )}
        </Box>
    );
};

const dynamicFilterOptions = useMemo(() => {
const options = {};
const selectAccessors = ['profile','uploadby'];

selectAccessors.forEach(key => {
    const uniqueValues = new Set();
    candidates.forEach(row => {
        if (row[key]) {
            uniqueValues.add(row[key]);
        }
    });
    options[key] = Array.from(uniqueValues).sort();
});
return options;
}, [candidates]);


const BASE_COLUMNS_DEFINITION = [
{ accessorKey: 'date', selector: (row) => row.date, filterType: 'date' },
        { accessorKey: 'name', selector: (row) => row.name, filterType: 'text' },
        { accessorKey: 'mobile',  selector: (row) => row.mobile, filterType: 'text' },
        { accessorKey: 'profile', selector: (row) => row.profile, filterType: 'select', dynamicFilterOptions:dynamicFilterOptions['profile'] },
          { 
            accessorKey: 'email', 
            selector: (row) => row.email, 
            filterType: 'text',
        },
];

  
 const processedData = useMemo(() => {
          let filtered = candidates;
          const lowerCaseFilter = globalFilterText.toLowerCase();
  
          // 1. Apply Global Filter
          if (lowerCaseFilter) {
              filtered = filtered.filter(row => 
                  BASE_COLUMNS_DEFINITION.some(column => {
                      const value = column.selector ? String(column.selector(row)) : '';
                      return value.toLowerCase().includes(lowerCaseFilter);
                  })
              );
          }
  
          // 2. Apply Column Filters
          filtered = filtered.filter(row => {
              return BASE_COLUMNS_DEFINITION.every(column => {
                  const accessorKey = column.accessorKey;
                  const filterValue = columnFilters[accessorKey];
  
                  if (!filterValue) return true;
                  if (!column.selector) return true;
  
                  const rowValue = String(column.selector(row));
  
                  switch (column.filterType) {
                      case 'select':
                          // Must match the selected value exactly
                          return rowValue === filterValue; 
                          
                      case 'date':
                          // Check if the date string (e.g., '2024-01-15') includes the filter date
                          return rowValue.includes(filterValue); 
                          
                      case 'text':
                      default:
                          return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                  }
              });
          });
  
          // 3. Sorting Logic
          const sortColumn = BASE_COLUMNS_DEFINITION.find(col => col.selector === orderBySelector);
  
          if (sortColumn) {
              return stableSort(filtered, getComparator(order, sortColumn.selector));
          }
          
          return filtered;
  
 }, [candidates, BASE_COLUMNS_DEFINITION, order, orderBySelector, globalFilterText, columnFilters]);
 
const columns = useMemo(() => {
          let baseColumns = [
             { 
                   accessorKey: 'date', 
                   header: 'Date Time', 
                   size: 180, // Increased size slightly to accommodate the button
                   selector: (row) => row.date, 
                   filterType: 'date',
                   Cell: ({ row: { original: rowData } }) => {
                     const isViewDetailClickable = !!rowData.id; 
                     
                     return (
                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                         <span>{rowData.date}</span>
                         <Tooltip title={isViewDetailClickable ? 'View Detail' : ''} arrow>
                           <IconButton
                             size="small"
                             onClick={(e) => {
                               e.stopPropagation(); // Prevents triggering row selection logic
                               EditData(rowData.id, 2);
                             }}
                             sx={{
                               color: 'orange',
                               p: 0.5,
                               '&:hover': {
                                 color: isViewDetailClickable ? '#0056b3' : 'text.disabled',
                                 backgroundColor: 'transparent'
                               }
                             }}
                           >
                             <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                           </IconButton>
                         </Tooltip>
                       </Box>
                     );
                   }
                 },
              { accessorKey: 'name', header: 'Name', size: 150, selector: (row) => row.name, filterType: 'text' },
              { accessorKey: 'mobile', header: 'Mobile', size: 150, selector: (row) => row.mobile, filterType: 'text' },
              { accessorKey: 'profile', header: 'Profile', size: 150, selector: (row) => row.profile, filterType: 'select', dynamicFilterOptions:dynamicFilterOptions['profile'] },
               { 
                  accessorKey: 'email', 
                  header: 'Email', 
                  size: 150, 
                  selector: (row) => row.email, 
                  filterType: 'text',
              },
             { 
                  accessorKey: 'exp', 
                  header: 'Experience', 
                  size: 150, 
                  selector: (row) => row.exp, 
                  filterType: 'text',
              },
              { 
                  accessorKey: 'utype', 
                  header: 'Upload By', 
                  size: 150, 
                  selector: (row) => row.uploadby, 
                  filterType: 'select',
                  dynamicFilterOptions: dynamicFilterOptions['uploadby']
              }
          ];

         if (
  metaData.typess?.toUpperCase() === "ADMIN" ||
  metaData.del === 1 ||
  metaData.edit === 1
) {
  baseColumns.push({
    accessorKey: 'action',
    header: 'Action',
    size: 150,
    Cell: ({ row: { original: rowData } }) => {

      const isAdmin = metaData.typess?.toUpperCase() === "ADMIN";

      return (
        <Box sx={{ display: 'flex', gap: 1,}}>

          {(isAdmin || metaData.del === 1) && (
            <Tooltip title="Delete">
              <IconButton
                size="small"
                color="error"
                onClick={(e) => {
                  e.stopPropagation();
                  DeleteData(rowData.id);
                }}
              >
                <i className="ri-delete-bin-line"></i>
              </IconButton>
            </Tooltip>
          )}

          {(isAdmin || metaData.edit === 1) && (
            <Tooltip title="Edit">
              <IconButton
                size="small"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  EditData(rowData.id, 1);
                }}
              >
                <i className="ri-edit-line"></i>
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );
    },
    enableSorting: false,
    enableColumnFilter: false,
  });
}
         return baseColumns;
}, [dynamicFilterOptions,metaData]);
  
 const handleRequestSort = useCallback((selector) => {
          const isAsc = orderBySelector === selector && order === 'asc';
          setOrder(isAsc ? 'desc' : 'asc');
          setOrderBySelector(() => selector);
 }, [order, orderBySelector]);


  if (newloading) {
    
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/90 z-50">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

return(
<>
<BulkUploadResultsModal show={showResultsModal} onClose={() => setShowResultsModal(false)} results={results}/>

<button data-bs-toggle="modal" id="showRecruiterModal" data-bs-target="#RecruiterModal" type="button" style={{ display: 'none' }}></button>
<button data-bs-toggle="offcanvas" id="tera_modal3" data-bs-target="#exampleModal2" type="button" style={{ display: 'none' }}></button>
<button data-bs-toggle="modal" id="tera_modal33" data-bs-target="#tableModal" type="button" style={{ display: 'none' }}></button>

<div className="modal effect-super-scaled fade" id="tableModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
    <div className="modal-dialog modal-xl">
        <div className="modal-content">
            <div className="modal-header bg-light py-2">
                <h5 className="modal-title"><strong>Candidate Detail</strong></h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '85vh', overflowY: 'auto' }}>
                
                {/* 1. SECTION: CANDIDATE BASIC DETAILS */}
                <h6 className="text-primary mb-2"><strong>Personal Information</strong></h6>
                <table className="table table-bordered" style={{ tableLayout: "fixed", fontSize: '0.85rem' }}>
                    <tbody>
                        <tr>
                            <th style={{ backgroundColor: "#f0f7ff", width: '15%' }}>Name</th>
                            <td style={{ width: '35%' }}>{requirement.candidate_name || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff", width: '15%' }}>Mobile</th>
                            <td style={{ width: '35%' }}>{requirement.mobile || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff", width: '15%' }}>Email</th>
                            <td style={{ width: '35%' }}>{requirement.email || "-"}</td>
                        </tr>
                        <tr>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Age</th>
                            <td>{requirement.age || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Added By</th>
                            <td colSpan="3">{requirement.addedby || "-"}</td>
                        </tr>
                        <tr>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Candidate Location</th>
                            <td>{requirement.location || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Pincode</th>
                            <td>{requirement.pincode || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Profile</th>
                            <td>{requirement.profile || "-"}</td>
                        </tr>
                        <tr>
                            
                            <th style={{ backgroundColor: "#f0f7ff" }}>Qualification</th>
                            <td>{requirement.qualification || "-"}</td>
                            
                            <th style={{ backgroundColor: "#f0f7ff" }}>Experience</th>
                            <td>{requirement.exp || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Added Time</th>
                            <td>{requirement.datestimes || "-"}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='modal-footer py-1'>
                <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


 <div className="modal fade effect-horizontal" id="RecruiterModal" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="exampleModalLabel1" style={{ display: 'none' }} aria-hidden="true">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="exampleModalLabel1">Choose Recruiter</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
           
              <div className="modal-body">
                      <form noValidate>
                          
                       <div className='col-xl-12 col-lg-12 col-md-12'>
                       <label htmlFor='' className='form-label'>Select Staff</label>
                  
                  <Select
                    options={recruiter || []}   // must be an array
                    value={(recruiter || []).find(opt => opt.value == selectedRecruiter) || null}
                    onChange={(option) => selectRecruiter(option ? option.value : null)}
                    placeholder="Select Recruiter"
                  />
                  
                   </div>
                 <button type="submit" style={{marginTop:'10px',float:'right'}} className="btn btn-primary">Submit</button>
                      </form>
                     
              </div>
             
          </div>
        </div>
 </div>

<div className="offcanvas offcanvas-top" style={{maxHeight:'100%',height:'auto',backgroundColor:'rgb(245 245 245)'}} tabIndex="-1" id="exampleModal" >
    <div className="offcanvas-header border-bottom border-block-end-dashed">
         <h5 className="offcanvas-title" id="offcanvasRightLabel1">{metaData.appname}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose"  aria-label="Close"></button>
     </div>
<div className="offcanvas-body">
   
   <div className='d-flex'>

  <form id="mainForm" onSubmit={FormSubmit} encType="multipart/form-data" className='order-2'>
<div className="row g-3" style={{position:'relative'}}>
          		<div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="name" className="form-label">Name</label>
                      <input  id="name" name="name" className="form-control" autoComplete='off'  placeholder='Candidate Name' required />
                </div>
                <div className="col-lg-6">
                       <label htmlFor="mobile" className="form-label">Mobile No.</label>
                      <input  id="mobile" name="mobile" className="form-control" autoComplete='off' placeholder='Mobile No.' maxLength={10} minLength={10} inputMode='numeric' required defaultValue=""/>
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="email" className="form-label">Email</label>
                      <input  id="email" name="email"  type="email" className="form-control" autoComplete='off' placeholder='Email adddress' required defaultValue=""/>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="profile" className="form-label">Profile</label>
                      <input  id="profile" name="profile" className="form-control" autoComplete='off' placeholder='Enter Your Profile' required defaultValue=""/>
                </div>

                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="age" className="form-label">Date of Birth</label>
                      <input type='date' id="age" name="age" className="form-control" autoComplete='off' required defaultValue=""/>
                </div>
                          <div className="col-lg-6">
  <label htmlFor="qual" className="form-label">Qualification</label>
  <Select
    id="qual"
    name="qual"
    options={qualificationOptions}
    placeholder="Select Qualification"
    isSearchable={true}
    // Find the option object that matches our state string
    value={qualificationOptions.find(obj => obj.value === filters.qual) || null}
    onChange={(selected) => handleSelectChange("qual", selected)}
    className={`react-select ${!filters.qual ? "is-invalid":""}`}
  />
</div>

<div className="col-lg-6">
  <label htmlFor="exp" className="form-label">Experience</label>
  <Select
    id="exp"
    name="exp"
    options={experienceOptions}
    placeholder="Enter Experience"
    isSearchable={true}
    // Find the option object that matches our state string
    value={experienceOptions.find(obj => obj.value === filters.exp) || null}
    onChange={(selected) => handleSelectChange("exp", selected)}
    className={`react-select ${!filters.exp ? "is-invalid":""}`}
  />
</div>
                <div className="col-lg-6">
                       <label htmlFor="pincode" className="form-label">Pincode</label>
                      <input  id="pincode" name="pincode" className="form-control" autoComplete='off' minLength={6} maxLength={6} placeholder='Enter Your Pincode' required defaultValue=""/>
                </div>

                <div className="col-lg-6">
                       <label htmlFor="city" className="form-label">City/District</label>
                      <input  id="city" name="city" className="form-control" autoComplete='off' placeholder='Enter City' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="state" className="form-label">State</label>
                      <input  id="state" name="state" className="form-control" autoComplete='off'  placeholder='Enter your State' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
                <div className="col-lg-2" id='resumelabel'>
                     {/* Category Input */}
                     <p className="form-label">Upload Resume</p>
                      <input id="resume" accept="image/*,.pdf" onChange={handleFileChange} name="resume" className="form-control" autoComplete='off' type='file' defaultValue="" style={{display:'none'}}/>
                      <label htmlFor="resume"  className='form-label' style={{width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <span style={{fontSize:'35px',marginTop:'-9px',display:'inline-block'}}>+</span>
                      </label>
                </div>
                <div className='col-lg-4' id='fileTxt'>
        {fileUrl && fileType?.startsWith('image/') && (
          <img src={fileUrl} alt="Preview" style={{ maxWidth: '100%' ,height:'150px'}} />
        )}

        {fileUrl && fileType == 'application/pdf' && (
          <iframe src={fileUrl} title="PDF Preview" style={{width:'100%',height:'150px'}}></iframe>
        )}

        {fileUrl && !fileType.startsWith('image/') && fileType != 'application/pdf' && (
          <p>File preview not supported for this file type.</p>
        )}
      </div>
        
             <div className='col-12'  style={{padding:'0px',textAlign:'right'}}>
              <input type="hidden" name="hidden" id="hidden" />
              <input type='hidden' name='aid' id='aid' value={aid}/>
              <input type="hidden" name="token" value={sessionStorage.getItem('token')}/>
              <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{marginRight:'20px',display:'none'}}/>
            <button type="submit" className="btn btn-primary">Submit</button>
            </div>
    </div>
      </form>

      <img className="order-1" src={process.env.PUBLIC_URL + "/admin_assets/images/media/media-88.svg"} style={{width:'100%',height:'100%'}}/> 

   </div>
   
 
</div>

</div>

<div className="offcanvas offcanvas-end" style={{width:'45%',height:'auto',backgroundColor:'rgb(245 245 245)'}} tabIndex="-1" id="bulkmodal" >
    <div className="offcanvas-header border-bottom border-block-end-dashed">
         <h5 className="offcanvas-title" id="offcanvasRightLabel1">Candidate Registration in Bulk</h5>
        <button type="button" className="btn-close" id='modalclose2' data-bs-dismiss="offcanvas" aria-label="Close"></button>
     </div>
<div className="offcanvas-body">
   <form id="bulkform" onSubmit={BulkFormSubmit} encType="multipart/form-data">
<div className="row g-3" style={{position:'relative'}}>
          		<div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="name2" className="form-label">Spoc Name</label>
                      <input  id="name2" name="name2" className="form-control" autoComplete='off'  placeholder='Spoc Name' required defaultValue=""/>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="mobile2" className="form-label">Spoc Mobile No.</label>
                      <input  id="mobile2" name="mobile2" className="form-control" autoComplete='off' placeholder='Spoc Mobile No.' maxLength={10} minLength={10} inputMode='numeric' required defaultValue=""/>
                </div>
             
                <div className="col-lg-6">
                       <label htmlFor="location2" className="form-label">Spoc Location</label>
                      <input  id="location2" name="location2" className="form-control" autoComplete='off' placeholder='Spoc Location' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
                <div className="col-lg-6" style={{display:'flex',width:'100%'}}>
                                    <button className="btn btn-sm btn-danger" onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL}demo/download.php?tt=1`;}} type="button">Sample Bulk File Download</button>
                                    <button className="btn btn-sm btn-info" style={{marginLeft:'20px'}} onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL}demo/download.php?tt=2`;}} type="button">CSV File Steps PDF</button>
                    </div>

                <div className='col-12'>
                  <p className="form-label">Scan File</p>
                      <input id="bulk" style={{display:'none'}}  accept=".csv" name="bulk" className="form-control" autoComplete='off' type='file' defaultValue=""  onChange={handleFileChange2}/>
                    <label htmlFor="bulk"  className='form-label' style={{float:'left',marginRight:'30px',width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <i className='ri-qr-scan-2-line' style={{fontSize:'25px'}}></i>
                      </label>
                       {/* File Info */}
        {fileInfo && (
          <div style={{marginTop:'10px',float:'left'}}>
            <div style={{ fontWeight: "500" }}>{fileInfo.name}</div>
            <small style={{ color: "#6c757d" }}>
              {(fileInfo.size / 1024).toFixed(2)} MB
            </small>
          </div>
        )}
                </div>
     
             <div className='col-12' style={{padding:'0px',textAlign:'right',position:'fixed',bottom:'20px',right:'20px'}}>
              <input type='hidden' name='aid' id='aid' value={aid}/>
              <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{marginRight:'20px',display:'none'}}/>
            <button type="submit" className="btn btn-primary">Upload</button>
            </div>
    </div>
      </form>
</div>

</div>

<div className="main-content app-content">
                 
 <div className="container-fluid">

   <div className="row">

<div class="col-xl-12 mt-4">
    <div class="card custom-card">
        <div class="card-header" style={{display:'flex',justifyContent:'space-between'}}><div class="card-title">Candidate Stats</div>
          <Tooltip title="Download Candidates Data" arrow>
          <IconButton
            size="medium"
            onClick={() => {
              window.location = `${apiurl}download.php?subdomain=react&export=xls&aid=${aid}&aidtype=${aidtype}`;
            }}
            sx={{
              color: '#fff',
              background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
              borderRadius: '10px',
              p: 1,
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.35)',
              transition: 'all 0.25s ease',
              '&:hover': {
                background: 'linear-gradient(135deg, #0d47a1, #1976d2)',
                transform: 'translateY(-1px)',
                boxShadow: '0 6px 16px rgba(13, 71, 161, 0.45)',
              },
              '&:active': {
                transform: 'scale(0.95)',
              },
            }}
          >
            <DownloadOutlined sx={{ fontSize: '1.4rem' }} />
          </IconButton>
        </Tooltip>
          <button className="btn btn-primary ms-2" onClick={()=> navigate(-1)}>Back</button>
        </div>
        <div class="card-body">
            <div class="row gy-md-0 gy-3" style={{gap:'15px 60px'}}>
 
 {stats.map((item, index) => (
 
 <div class="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12" key={index}>
                    <div class="d-flex align-items-top">
                        <div>
                            <span class="d-block mb-1 text-muted">{item.label}</span>
                            <h6 class="fw-semibold mb-0">{item.count}</h6>
                        </div>
                    </div>
                </div>

  ))}
 </div>
 
        </div>
    </div>
</div>

</div>

<div className="row">
   
<div className="col-xxl-12 col-xl-12 ">
   
<div className="card custom-card">
  
<div className="card-header justify-content-between" style={{ paddingBottom: '15px', alignItems: 'normal' }}>
                  <div>
                    <h6 className="fs-16">{metaData.appname}</h6>
                  </div>
                  <div className="d-flex mt-sm-0 mt-2 align-items-center">
                   
                             <div className="input-group" style={{width:'auto'}}>
                                <input type="text" className="form-control bg-light border-0" placeholder="Search Candidate" aria-describedby="search-contact-member" />
                                <button className="btn btn-light" style={{zIndex:'0'}} type="button" id="search-contact-member"><i className="ri-search-line text-muted"></i></button>
                            </div>
      
         <button className="btn btn-primary ms-2" data-bs-toggle="offcanvas" id="bulkupload" data-bs-target="#bulkmodal">Bulk Upload</button>
         <button className="btn btn-icon btn-primary ms-2" data-bs-toggle="offcanvas" id="addStaffbtn" data-bs-target="#exampleModal" ><i className="ri-add-line" data-tooltip-content="Add Candidate" data-tooltip-id='global-tooltip'></i></button>
    
                
                  </div>

                </div>
                 <div className="card-body" style={{ padding: '0px' }}>
 
            <TableContainer sx={{ maxHeight: '700px'}}>
                 <Table stickyHeader aria-label="requirement tracker table">
                     
                     <TableHead>
                         <TableRow>
                             {columns.map((column) => (
                                 <TableCell
                                     key={column.accessorKey}
                                     sx={{ 
                                         whiteSpace: 'nowrap',
                                         overflow: 'hidden',
                                         textOverflow: 'ellipsis',
                                         p: 2.5,
                                         fontSize: '0.85rem', 
                                         verticalAlign: 'top',
                                     }}>
                                     <ColumnHeaderWithFilter
                                         column={column}
                                         orderBySelector={orderBySelector}
                                         order={order}
                                         handleRequestSort={handleRequestSort}
                                         columnFilters={columnFilters}
                                         setColumnFilters={setColumnFilters}
                                     />
                                 </TableCell>
                             ))}
                         </TableRow>
                     </TableHead>
 
 
  <TableBody>
     {processedData.map((row, index) => {
         return(
         <TableRow  >
             {columns.map((column) => {
                 let cellContent;
                 const cellWidth = column.size ? column.size : 150;
                  
                 if (column.Cell) {
                     cellContent = column.Cell({ row: { original: row } });
                 }
                 // 2. Handle specific accessorKeys with custom logic (like 'rid')
                 else {
                         const value = column.selector ? column.selector(row) : null;
                         cellContent = value;
                 
               }
                 return (
                     <TableCell 
                         key={column.accessorKey}
                         sx={{ p: 1.5, fontSize: '0.875rem',minWidth:cellWidth,width:cellWidth}}>
                         {cellContent}
                     </TableCell>
                 );
             })}
         </TableRow>
         );
 })}
     
     {/* Empty state if no data */}
     {processedData.length === 0 && (
         <TableRow>
             <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                 <Typography color="textSecondary" variant="body1">
                     No matching found in the current filters.
                 </Typography>
             </TableCell>
         </TableRow>
     )}
 </TableBody>
                
             </Table></TableContainer>
           
                 </div>
                <div className="card-footer d-flex align-items-center justify-content-between" style={{ padding: '10px 25px' }}>
    <p className="text-muted mb-0">
        Showing <strong>{((currentPage - 1) * limit) + 1}</strong> – <strong>{Math.min(currentPage * limit, totalRows)}</strong> of <strong>{totalRows}</strong> entries
    </p>

    <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
            {/* First Page */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(1)}>« First</button>
            </li>

            {/* Previous */}
            <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>&laquo;</button>
            </li>

            {/* Dynamic Page Numbers */}
            {pages.map(pageNum => (
                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNum)}>
                        {pageNum}
                    </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${currentPage >= maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>&raquo;</button>
            </li>

            {/* Last Page */}
            <li className={`page-item ${currentPage === maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(maxPage)}>Last »</button>
            </li>
        </ul>
    </nav>
                </div>
</div>
        
</div></div>

</div></div>

</>
);
}
export default Demo;